<template>
    <ihlp-carousel v-if="dataList.length>0" :dataList="dataList" :cfg="cfg" @onClick='advertClick'></ihlp-carousel>
</template>
<script>
//som广告位专用轮播
import { mapGetters, mapState } from "vuex";
export default {
    name:"ihlpCarouselBanner",
    computed: {
        ...mapGetters({
            bannerDataList: "base/getBannerData"
        })
    },
    props: {
        value: {
            type: [String, Array],
            default: ''
        },
        place:{
            type: String,
            default: ''
        }
    },
    data () {
        return {
            dataList:[],
            cfg:{},

        }
    },
    created(){
        if(this.bannerDataList.length>0){
            this.setDataList(this.bannerDataList)
        }else{
            this.$store.dispatch('base/getBannerDataAction');
        }
    },
    watch: { 
        bannerDataList(newValue,oldValue){
            this.setDataList(newValue)
        }
    },
    methods:{
        setDataList(list){
            let self=this,dataList=[];
            list=list||[]
            for(let i=0;i<list.length;i++){
                let item = list[i]
                if(item.place==self.place){
                    item.showImageUrl=self.$utils.getImageUrl(item.imgSrc);
                    //图片是否可以点击
                    item.cursor=item.url||item.htmlStr?true:false;
                    let className=item.url||item.htmlStr?'cursor-pointer':'cursor-auto'
                    item.content="<img  class='img-background "+className+"' src="+item.showImageUrl+" />"
                    dataList.push(item)
                }
            }
            if(dataList.length>1){
                this.cfg.loop=true
            }
            this.dataList=dataList
        },
        //广告位点击
        advertClick(item){
            if(item.cursor){
                if(item.url){
                    if(item.url.indexOf("http:")>0){
                        window.open(item.url)
                    }else{
                        this.$router.push({path:item.url});
                    }
                }else if(item.htmlStr&&item.htmlStr){
                    window.open("#/bannerOpen/"+item.id, '_blank')
                }
                
            }
            
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/common/carousel/carouselBanner.vue